export const form_data = {
  new_provider_id:{
    value: null,
    error: false,
    isVisited: false,
    isRequired: false,
    isValid: false,
    options:[],
    config:{
      id:'new_provider_id',
      type:'select',
      fullWidth: true,
      md:12
    },
    rules:{
      type:'none',
    }
  },
}